<template>
    <div class="schedule">
       <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.title || "Weekly schedule" }}</h2>
            </div>
            <div class="right">
                <v-btn @click="newScheduleModal = true"
                color="primary" dark>
                    <v-icon small class="mr-2">mdi-plus</v-icon>
                    {{ $page.props.lang.newSchedule || "New Schedule" }}
                </v-btn>
            </div>
        </div>

        <div v-if="!onDayView" class="calendar-week">
            <div class="hours">
                <div v-for="(hour, index) in 18" :key="index" class="hour">
                    <p class="hour-slot">{{ index + 6  }}:00</p>
                </div>
            </div>
            <div class="days">
                <div v-for="day in realWeekDays" :key="day.value" class="day">
                    <div class="day-header">
                        <p class="day-header-title">{{ day.text.substr(0,2) }}</p>
                    </div>
                    <div class="day-slots">
                        <div v-for="(hour, index) in 18" :key="index" class="day-hour-slot">

                        </div>

                        <div
                        v-for="event in day.events" :key="event.title"
                        :style="{ top: event.startInterval + 'px', height: event.duration + 'px' }"
                        class="event-wrap">
                            <div class="event" :style="{ backgroundColor : $page.props.organization.themeOptions.primary}">
                                <div class="top-row">
                                    <p class="event-time">{{ event.start_at}} - {{ event.end_at }}</p>
                                    <v-menu top right>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            dark x-small
                                            icon
                                            v-bind="attrs"
                                            v-on="on">
                                                <v-icon dark small>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list expand nav dense>
                                            <v-list-item @click="getSchedule(event)" link v-show="$page.props.p['members.manage']">
                                                <v-list-item-title>{{ $page.props.lang.editSchedule  || "Edit schedule" }}</v-list-item-title>
                                                <v-list-item-icon><v-icon>mdi-pencil-outline</v-icon></v-list-item-icon>
                                            </v-list-item>
                                            <v-list-item @click="deleteSchedule(event.id, event.courses)" link v-show="$page.props.p['members.manage']">
                                                <v-list-item-title>{{ $page.props.lang.deleteSchedule || "Delete schedule" }}</v-list-item-title>
                                                <v-list-item-icon><v-icon>mdi-trash-can-outline</v-icon></v-list-item-icon>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                                <div class="schedule-class-wrap">
                                    <p class="class-titles">
                                        {{ event.courses.map(el => el.title).join(', ') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="onDayView" class="calendar-day">
            <div class="calendar-day-nav">
                <div @click="changeDay(day.id)" v-for="day in weekDays" :key="day.id"
                :class="{ 'active' : day.id===realCurrentDay.id }" class="day-nav-item">
                    <p class="item-title">{{ day.text.substr(0,3) }}</p>
                </div>
            </div>
            <div class="calendar-day-container">
                <div class="hours">
                    <div v-for="(hour, index) in 18" :key="index" class="hour">
                        <p class="hour-slot">{{ index + 6  }}:00</p>
                    </div>
                </div>
                <div class="days">
                    <div class="day">
                        <div class="day-slots">
                            <div v-for="(hour, index) in 18" :key="index" class="day-hour-slot">

                            </div>
                            <div
                            v-for="event in realCurrentDay.events" :key="event.title"
                            :style="{ top: event.startInterval + 'px', height: event.duration + 'px' }"
                            class="event-wrap">
                            <div class="event">
                                <p class="event-title">{{ event.start_at }} - {{ event.end_at }}</p>
                                 <p class="schedule-class-wrapper">
                                    <span v-for="c in event.courses" v-bind:key="c.id" class="schedule-class">{{c.title}}</span>
                                </p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="newScheduleModal" max-width="500px" content-class="new-schedule">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.newSchedule || "New Schedule" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="newScheduleModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <div class="fields">
                            <div class="grid">
                                <p class="custom-label">{{ $page.props.lang.course || 'Course' }}</p>
                                <v-select
                                v-model="newSchedule.course_ids"
                                :items="courses"
                                item-text="title"
                                item-value="id"
                                multiple
                                chips
                                dense outlined flat
                                :error-messages="responseErrors.course_ids" @focus="responseErrors.course_ids=''"
                                ></v-select>
                                <p class="custom-label">{{ $page.props.lang.day || 'Day' }}</p>
                                <v-select
                                v-model="newSchedule.day"
                                :items="weekDays"
                                item-text="text"
                                item-value="value"
                                persistent-hint
                                dense outlined flat
                                :error-messages="responseErrors.day" @focus="responseErrors.day=''"
                                ></v-select>
                                <div class="vue-timepicker-wrap">
                                    <p class="custom-label">{{ $page.props.lang.from || "From" }}</p>
                                    <vue-timepicker
                                    v-model="newSchedule.start_at"
                                    close-on-complete hide-disabled-items hide-clear-button fixed-dropdown-button format=""
                                    :minute-interval="15" :hour-range="[[5,23]]"
                                    @open="responseErrors.start_at=[]"
                                    :class="responseErrors.start_at && responseErrors.start_at.length>0 ? 'has-error' : ''">
                                        <template v-slot:dropdownButton>
                                            <v-icon>mdi-menu-down</v-icon>
                                        </template>
                                    </vue-timepicker>
                                    <p v-if="responseErrors.start_at"
                                    class="custom-errors v-bounce">
                                    {{ responseErrors.start_at[0] }}
                                    </p>
                                </div>
                                <div class="vue-timepicker-wrap">
                                    <p class="custom-label">{{ $page.props.lang.to || "To" }}</p>
                                    <vue-timepicker
                                    v-model="newSchedule.end_at"
                                    close-on-complete hide-disabled-items hide-clear-button fixed-dropdown-button format=""
                                    :minute-interval="15" :hour-range="[[5,23]]" @open="responseErrors.end_at=[]"
                                    :class="responseErrors.end_at && responseErrors.end_at.length>0 ? 'has-error' : ''" drop-direction="up">
                                        <template v-slot:dropdownButton>
                                            <v-icon>mdi-menu-down</v-icon>
                                        </template>
                                    </vue-timepicker>
                                    <p v-if="responseErrors.end_at"
                                    class="custom-errors v-bounce">
                                    {{ responseErrors.end_at[0] }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="createNew" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editScheduleModal" max-width="500px" content-class="new-schedule">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editSchedule || "Edit Schedule" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="editScheduleModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <div class="fields">
                            <div class="grid">
                                <p class="custom-label">{{ $page.props.lang.course || 'Course' }}</p>
                                <v-select
                                v-model="currentScheduleData.course_ids"
                                :items="courses"
                                item-text="title"
                                item-value="id"
                                multiple
                                chips
                                dense outlined flat
                                :error-messages="responseErrors.course_ids" @focus="responseErrors.course_ids=''"
                                ></v-select>
                                <p class="custom-label">{{ $page.props.lang.day || 'Day' }}</p>
                                <v-select
                                v-model="currentScheduleData.day"
                                :items="weekDays"
                                item-text="text"
                                item-value="value"
                                persistent-hint
                                dense outlined flat
                                :error-messages="responseErrors.day" @focus="responseErrors.day=''"
                                ></v-select>
                                <div class="vue-timepicker-wrap">
                                    <p class="custom-label">{{ $page.props.lang.from || "From" }}</p>
                                    <vue-timepicker
                                    v-model="currentScheduleData.start_at"
                                    close-on-complete hide-disabled-items hide-clear-button fixed-dropdown-button format="hh:mm"
                                    :minute-interval="15" :hour-range="[[5,23]]"
                                    @open="responseErrors.start_at=[]"
                                    :class="responseErrors.start_at && responseErrors.start_at.length>0 ? 'has-error' : ''">
                                        <template v-slot:dropdownButton>
                                            <v-icon>mdi-menu-down</v-icon>
                                        </template>
                                    </vue-timepicker>
                                    <p v-if="responseErrors.start_at"
                                    class="custom-errors v-bounce">
                                    {{ responseErrors.start_at[0] }}
                                    </p>
                                </div>
                                <div class="vue-timepicker-wrap">
                                    <p class="custom-label">{{ $page.props.lang.to || "To" }}</p>
                                    <vue-timepicker
                                    v-model="currentScheduleData.end_at"
                                    close-on-complete hide-disabled-items hide-clear-button fixed-dropdown-button format=""
                                    :minute-interval="15" :hour-range="[[5,23]]" @open="responseErrors.end_at=[]"
                                    :class="responseErrors.end_at && responseErrors.end_at.length>0 ? 'has-error' : ''" drop-direction="up">
                                        <template v-slot:dropdownButton>
                                            <v-icon>mdi-menu-down</v-icon>
                                        </template>
                                    </vue-timepicker>
                                    <p v-if="responseErrors.end_at"
                                    class="custom-errors v-bounce">
                                    {{ responseErrors.end_at[0] }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="editSchedule()" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import TrainerLayout from './Layouts/Default'
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import EventBus from '@/js/eventbus'
import ConfirmModal from '@/js/Components/ConfirmModal'



export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.pageTitle || "Trainer roster"
        }
    },
    layout: (h, page) => {
      return h(AppLayout, [
        h(TrainerLayout, [page]),
      ])
    },
    components: {
        VueTimepicker,
        ConfirmModal
    },
    props: {
        trainer: Object,
        courses: Array,
        schedule: Object,
        lang: Object
    },
    data() {
        return {
            scheduleData: this.schedule,
            deleteScheduleModal: false,
            newScheduleModal: false,
            editScheduleModal: false,
            currentScheduleData: {},
            messageObjects: [],
            scheduleForDeleteId: null,
            newSchedule: {
                member_id: this.trainer.id,
                course_ids: [],
                start_at: '',
                end_at: ''
            },
            time: [
                '6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '9:00', '9:30', '10:00',
                '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30'
            ],
            weekDays: [
                { id: 0, value:'MO', text: (this.lang.monday || 'Monday')},
                { id: 1, value:'TU', text: (this.lang.tuesday || 'Tuesday')},
                { id: 2, value:'WE', text: (this.lang.wednesday || 'Wednesday')},
                { id: 3, value:'TH', text: (this.lang.thursday || 'Thursday')},
                { id: 4, value:'FR', text: (this.lang.friday || 'Friday')},
                { id: 5, value:'SA', text: (this.lang.saturday || 'Saturday')},
                { id: 6, value:'SU', text: (this.lang.sunday || 'Sunday')},
            ],
            responseErrors: {},
            realCurrentDay: {}
        }
    },
    computed: {
        onDayView: {
            get() {
                if(this.$vuetify.breakpoint.xs===true || this.$vuetify.breakpoint.sm===true) {
                    return true
                } else {
                    return false
                }
            },
            set() {
                if(this.$vuetify.breakpoint.xs===true || this.$vuetify.breakpoint.sm===true) {
                    return true
                } else {
                    return false
                }
            }
        },
        realWeekDays() {
            let arr = Object.assign([], this.weekDays)
            arr.map(item => {
                item.events = this.schedule[item.value]
                // item.date = moment().startOf('week').add(item.id, 'days')
                item.events.map(event => {
                    let start = moment(event.start_at, "HH:mm:ss")
                    let end = moment(event.end_at, "HH:mm:ss")
                    let dif = end.diff(start)
                    let dayStart = moment("05:00:00", "HH:mm:ss")
                    let startDif = start.diff(dayStart)
                    event.startInterval = parseInt(moment.duration(startDif).asMinutes())
                    event.duration = parseInt(moment.duration(dif).asMinutes())
                })
            })
            return arr
        },
        // realCurrentDay: {
        //     get: function() {
        //         return Object.assign({}, this.realWeekDays[0])
        //     },
        //     set: function(value) {
        //         value = this.realWeekDays[value.id]
        //     }
        // }
    },
    created() {
        moment.updateLocale('en', {
            week: {
                dow: 1,
            },
        }),
        this.realCurrentDay = this.realWeekDays[0]
    },
    watch: {
        newScheduleModal(value) {
            if (value===false) {
                this.responseErrors = {}
                this.newSchedule = Object.assign({}, {
                    member_id: this.trainer.id,
                    course_ids:[],
                    start_at: {hh: '', mm: ''},
                    end_at: {hh: '', mm: ''}
                })
            } else {
                this.newSchedule = Object.assign({}, {
                    member_id: this.trainer.id,
                    course_ids:[],
                    start_at: '',
                    end_at: ''
                })
            }
        }
    },
    methods: {
        changeDay(id) {
            this.realCurrentDay = this.realWeekDays[id]
        },
        createNew(){
            axios.post('/backoffice/trainers/storeSchedule', this.newSchedule)
                .then(response => {
                    console.log(response)
                    if (response.data.status==="OK") {
                        this.$inertia.reload({only:['schedule']})
                        this.newScheduleModal = false

                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        },

        getSchedule(event){
            // this.editScheduleModal == true
            axios.get('/backoffice/trainers/'+ this.trainer.id +'/getSchedule/'+ event.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.editScheduleModal = true
                        this.currentScheduleData = response.data.schedule
                    }else{
                        alert("Server error.")
                    }
                })
        },

        editSchedule(){

            axios.post('/backoffice/trainers/updateSchedule', this.currentScheduleData)
            .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.reload({only:['schedule']})
                        EventBus.$emit('SHOW_NOTIFICATION', {
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                      this.editScheduleModal = false
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });

        },

        deleteSchedule(id, course_ids) {
            axios.post('/backoffice/trainers/deleteSchedule', {id: id, member_id: this.trainer.id, course_ids: course_ids})
                .then(response => {
                    if(response.data.status==="OK") {
                        // this.deleteScheduleModal = false
                        this.$inertia.reload({only:['schedule']})
                        EventBus.$emit('SHOW_NOTIFICATION', {
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
		}
    }
}
</script>
